import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import BusninessMobileNavbarItems from "./shared/BusninessMobileNavbarItems";
import NavbarItems from "./shared/NavbarItems";

const BussinessLayout = () => {
  const items = useSelector((store) => store.businessSidebar?.list);

  return (
    <div className="flex flex-col md:flex-row  md:gap-4  max-w-full w-full h-full ">
      <div className="hidden md:block bg-white  ">
        <NavbarItems sidebaritems={items} type={"business"} />
      </div>
      <div className="block md:hidden p-2  border-b-2 border-neutral-20">
        <BusninessMobileNavbarItems sidebaritems={items} type={"business"} />
      </div>

      <div className="flex-1 flex-shrink-0 overflow-hidden   ">
        <div className="h-full overflow-auto no-scrollbar">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default BussinessLayout;
